import { useEffect, useState } from 'react';

/**
 * Hook to load image and get its natural dimensions
 * @param imageUrl - URL of the image to load
 * @returns Image dimensions or null if not loaded or error occurred
 */
export const useImageDimensions = (imageUrl: string) => {
  const [dimensions, setDimensions] = useState<{ width: number; height: number } | null>(null);

  useEffect(() => {
    if (!imageUrl) {
      setDimensions(null);
      return;
    }

    const img = new Image();
    img.onload = () => {
      setDimensions({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      setDimensions(null);
    };
    img.src = imageUrl;
  }, [imageUrl]);

  return dimensions;
};
